export default {
  install() {
    if (
      ['127.0.0.1', 'localhost'].includes(window.location.hostname) ||
      import.meta.env.VITE_ONETRUST_ENABLED !== 'true'
    ) {
      return
    }
    const s = 'script'
    const sUrl = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
    const loadedScript = !!Array.from(window.document.getElementsByTagName(s)).find((se) =>
      se.src.includes(sUrl)
    )
    if (loadedScript) {
      return
    }
    const head = window.document.getElementsByTagName('head')[0]
    const js = window.document.createElement('script')

    js.src = sUrl
    js.async = true
    js.type = 'text/javascript'
    js.setAttribute('data-document-language', 'true')
    js.setAttribute('charset', 'utf-8')
    js.setAttribute('data-domain-script', import.meta.env.VITE_ONETRUST_DATA_DOMAIN_SCRIPT_LOAD)
    head.appendChild(js)

    const w = window as any
    w['OptanonWrapper'] = function () {
      if (w['OneTrust']?.IsAlertBoxClosed()) {
        // previously accepted cookies
        window.document.getElementById('onetrust-consent-sdk')!.style.display = 'none'
      } else {
        // cookies alertbox is showing, awaiting the user's decision
        w['OneTrust'].OnConsentChanged(function () {
          window.document.getElementById('onetrust-consent-sdk')!.style.display = 'none'
        })
      }
    }
  }
}
